import { ThemeConfig } from 'antd';

interface CustomTheme extends ThemeConfig {
  colors: {
    primaryGradient: string;
    secondaryGradient: string;
    secondaryColors: {
      frenchBlue: string;
      blueSapphire: string;
      chineseSilver: string;
      white: string;
      charcoalGrey: string;
    };
  };
}

const DEFAULT_THEME: CustomTheme = {
  token: {
    fontFamily: 'Roboto',
    colorPrimary: '#17527B',
    borderRadius: 10,
    colorTextBase: '#2c2f32',
  },
  components: {
    Input: {
      controlHeight: 42,
    },
    InputNumber: {
      controlHeight: 42,
    },
    Select: {
      controlHeight: 42,
    },
    DatePicker: {
      controlHeight: 42,
    },
    Pagination: {
      controlHeight: 42,
    },
    // Button: {
    //   controlHeight: 42,
    // },
    Skeleton: {
      controlHeight: 42,
    },
    Checkbox: {
      borderRadiusSM: 4,
    },
    Table: {
      cellFontSize: 18,
      fontSize: 18,
      cellFontSizeSM: 16,
      cellFontSizeMD: 18,
      fontWeightStrong: 800,
    },
  },
  colors: {
    primaryGradient: 'linear-gradient(0deg, #17527B, #0071BC)', // Added primary gradient
    secondaryGradient: 'linear-gradient(0deg, #2D343C, #CCCCCC)', // Added secondary gradient
    secondaryColors: {
      frenchBlue: '#0071BC',
      blueSapphire: '#17527B',
      chineseSilver: '#17527B',
      white: '#FFFFFF',
      charcoalGrey: '#2D343C',
    },
  },
};

export default DEFAULT_THEME;
